module.exports = __webpack_public_path__ + "img/battery_gray.180fd61a.svg";